"use client";

import { usePathname } from "next/navigation";

export function NotFound({ host: _host }: { host: string }) {
  const pathname = usePathname() ?? "";
  const bookingLost = pathname.startsWith("/booking");

  return (
    <main className="flex min-h-screen items-center justify-center bg-subtle px-6 py-16 text-center">
      <div className="w-full max-w-xl">
        <img className="mx-auto mb-12 w-44" src="/ikigai-logo.svg" alt="Ikigai Real Estate" width="522" height="144" />
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-emphasis">Page not found</p>
        <h1 className="mt-3 font-cal text-4xl font-semibold text-emphasis sm:text-5xl">{bookingLost ? "This booking link has expired" : "This page isn’t here"}</h1>
        <p className="mx-auto mt-4 max-w-md text-base leading-7 text-subtle">The page may have moved or the link may be out of date. We can help you find your way back.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <a className="rounded-md bg-brand px-5 py-3 font-medium text-white" href="https://ikigaire.ae">Visit Ikigai Real Estate</a>
          <a className="rounded-md border border-subtle bg-default px-5 py-3 font-medium text-emphasis" href="/team/ikigai/private-tour-with-ikigai-real-estate">Book a private tour</a>
        </div>
      </div>
    </main>
  );
}
